package uk.co.nickthecoder.kyd.appearance

import uk.co.nickthecoder.glok.text.BitmapFont
import uk.co.nickthecoder.glok.text.BitmapGlyphData
import uk.co.nickthecoder.glok.text.FontStyle
import uk.co.nickthecoder.kyd.*

class Font(

    parent: ParentResource,
    name: String

) : AbstractParentResource(parent, name), FileResource, AppearanceResource {

    override val filename = "$name.png"

    var family: String = ""
    var size: Float = 12f
    var style: FontStyle = FontStyle.PLAIN

    var spacingX = 2
    var spacingY = 2

    var paddingTop = 0
    var paddingRight = 0
    var paddingBottom = 0
    var paddingLeft = 0

    /**
     * Every glyph's advance is incremented by this amount.
     * Useful if you make the glyphs bigger and want to space them out.
     */
    var extraAdvance = 0

    /**
     * The [bitmapFont]'s height is larger than the original by this amount.
     * Useful if you make the glyphs bigger and want to space them out.
     */
    var extraHeight = 0

    var height: Float = 1f
    var ascent: Float = 0f
    var descent: Float = 0f
    var top: Float = 0f
    var bottom: Float = 0f
    var italicInverseSlope: Float = 0f

    lateinit var bitmapFont: BitmapFont

    val glyphDataMap = mutableMapOf<Char, BitmapGlyphData?>()

    override val resourceType: ResourceType
        get() = ResourceType.FONT


    override fun appearanceForActor(actor: Actor): Appearance = Label(this, "").apply {
        tint = actor.appearance.tintIfAvailable
    }

    override fun appearance() = Label(this, "Aa")

}
